export default "__VITE_ASSET__BcMHHbG$__"